import React,{useState} from 'react';
import './index.scss'

import Lottie from 'react-lottie';
import animationData from './datarespaldo.json';







const Animacion = () => {

  let Altura
  let Ancho

    if(window.innerWidth>1200){
      Altura ='68vh';
      Ancho = '40vw';
    }else if(window.innerWidth>1000){     
      Altura ='68vh';
      Ancho = '50vw';
    }else if(window.innerWidth>800){     
      Altura ='35vh';
      Ancho = '78vw';
    }else if(window.innerWidth>850 && window.innerHeight<1200){     
      Altura ='80vh';
      Ancho = '40vw';
    }else if(window.innerWidth>700){     
      Altura ='68vh';
      Ancho = '40vw';
    }else{
      Altura ='40vh';
      Ancho = '90vw';
    }

    const [state, setState] = useState(false)

    setTimeout(function(){
     setState(true)
     }, 1500);
  
    return (
      <div className='containerAnimacionGeneral'>
        <div className='Espacio'></div>
        <div className='containerAnimacion'>
        
        <Lottie 
          options={
          {
              loop: false, 
              autoplay: state,        
              animationData: animationData,      
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              
          }}}

          height={Altura}
          width={Ancho}
        />
      </div>
      </div>
     
    );
}

export default Animacion;